<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="surveyQuestionTypes"
    item-value="name"
    item-text="description"
    return-object
  >
  </v-select>
</template>

<script>
import ApiService from "../../services/api.service";

export default {
  name: "SurveyQuestionTypeField",
  props: {
    value: Object
  },
  data: () => ({
    surveyQuestionTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    }
  },
  mounted() {
    ApiService.get("/api/types/surveyQuestionTypes", {}).then(({ data }) => {
      this.surveyQuestionTypes = data;
    });
  }
};
</script>
